import React, { memo, useEffect, useCallback, useContext } from "react";
import { Resizable } from "react-resizable";
import "./styles.css";
import { LoadMapContext } from "../../../../pages/sections/web-map/LoadWebMap";
import { WebMapContext } from "../../../../pages/sections/web-map/WebMapGoogleMap";

const ResizableComponent = ({
    children,
    resizeHandles,
    maxConstraints,
    minConstraints,
    heightUnit,
    widthUnit,
    height,
    width,
    onResize,
}) => {

    const { mapView, showMsModal } = useContext(LoadMapContext);
    const { mapPlacement } = useContext(WebMapContext);


    const calculateLeft = () => {
        if (mapView === null) {
            return "336px";
        } else if (mapPlacement === "left") {
            return "335px";
        } else {
            return "0px";
        }
    };
    

    return (
        <Resizable onResize={onResize} width={width} height={height} resizeHandles={resizeHandles} maxConstraints={maxConstraints} minConstraints={minConstraints}>
            <div
                style={{
                    width: width + widthUnit,
                    height: height + heightUnit,
                    top: 'calc(95.3vh - ' + height + heightUnit + ')',
                    left: calculateLeft(),
                    marginTop: '20px',
                    position: 'fixed',
                    backgroundColor: 'white',
                    zIndex: 3,

                    borderRadius: '10px',
                    overflow: 'hidden',
                    padding: '10px',

                }}
            >
                {children}
            </div>
        </Resizable>
    )

}

export default memo(ResizableComponent);
